import { ARServiceItemList } from '@/models/airRoad';

export const installationOptions = [
  { text: 'Unpack, position and test', value: 'DLVPOS' },
  { text: 'Deliver only', value: 'DLVONLY' },
  { text: 'Basic TECH1', value: 'TECH1' },
  { text: 'Standard TECH2', value: 'TECH2' },
  { text: 'Full TECH3', value: 'TECH3' },
];

export const installationOptionsText = {
  DLVPOS: 'Plugin and test if applicable',
  DLVONLY: 'Delivery only. Will be left packed',
  TECH1: `Set IP, call IT to configure and confirm the device is connected to the network.
    20mins allocated to installation.`,
  TECH2: `Set up main functions and train end-user. Configuration details required to complete set-up.
    40mins allocated to installation.`,
  TECH3: `Set up main functions and train end-user. High-level installation where no configuration details are
    available. 80mins allocated to installation.`,
};

export const breakFixServices = [
  { text: 'Field Service', value: 'FSC1M' },
  { text: 'Field Service - Two men', value: 'FSC2M' },
  { text: 'Smart Courier', value: 'SCR' },
];

export const breakFixServicesText = {
  FSC: 'Field Service Call description',
  SCR: 'Smart Courier Call description',
};

export const returnOptionsList = ['Store', 'Recycle', 'Return', 'Workshop'];
export const returnOptions = [
  { text: 'Stored', value: 'Store' },
  { text: 'Recycled', value: 'Recycle' },
  { text: 'Forward to', value: 'Return' },
  { text: 'Perform Task', value: 'Workshop' },
];

export const returnOptionsTexts = {
  0: 'Items will be placed in storage if scrap, return or workshop is not selected',
  1: 'Items will be sent for recycling',
  2:
    'For non-urgent deliveries back to your warehouse or an alternative location. ' +
    'Please add final address in delivery instructions',
  3:
    'Items will be moved to KK workshop for runup/refurb. ' +
    'Please add instructions for task in the Notes section of the last stop, ' +
    'what to do after the task is complete',
};

export const notificationErrorText =
  'Call the helpful team for assistance on 02 9575 0000 or email to kkts_it@kkts.com.au';

export const jobItemsTypes = [
  { text: 'Carton', value: 1 },
  { text: 'Pallet', value: 2 },
];

export const arJobStatuses = [
  { text: 'Not booked', value: 0 },
  { text: 'Booked', value: 1 },
  { text: 'In transit', value: 2 },
  { text: 'PoD received', value: 3 },
  { text: 'Failed to book', value: 1001 },
  { text: 'Queued to book', value: 1002 },
];

export const statesTimeZonesList = {
  WA: {
    timezone: 'Australia/Perth',
    code: 'AWST',
  },
  NT: {
    timezone: 'Australia/Darwin',
    code: 'NT',
  },
  SA: {
    timezone: 'Australia/Adelaide',
    code: 'ACDT',
  },
  QLD: {
    timezone: 'Australia/Brisbane',
    code: 'AEST',
  },
  TAS: {
    timezone: 'Australia/Tasmania',
    code: 'AET',
  },
  VIC: {
    timezone: 'Australia/Victoria',
    code: 'AEDT',
  },
  ACT: {
    timezone: 'Australia/Victoria',
    code: 'ACT',
  },
  NZ: {
    timezone: 'Pacific/Auckland',
    code: 'NZDT',
  },
  NSW: {
    timezone: 'Australia/Sydney',
    code: 'AEDT',
  },
};

export const timeZoneDefault = 'Australia/Sydney';

export const warehouseStatusList = {
  D: 'Despatch',
  I: 'Incoming',
  S: 'Stock',
  T: 'Transit',
  X: 'Unknown',
};

export const zammadTicketRfcStatuses = [
  'NEW',
  'OPEN',
  'PENDING_REMINDER',
  'PENDING_CLOSE',
  'AWAITING_DIMS',
  'AWAITING_CUSTOMER',
];

// TODO: REFACTOR TO USE FROM CATALOG API?
//       OR TO CREATE AN OBJECT
// THIS IS TO USE AS HARDCODED DIVISIONS
export const kktsDivisions = ['SYDNEY', 'BRISBANE', 'ADELAIDE', 'MELBOURNE', 'PERTH', 'DARWIN', 'CANBERRA'];

// THIS IS FOR SPLIT TO BASE FUNCTION
export const kktsSplitToBase = ['SYDNEY', 'BRISBANE', 'MELBOURNE', 'ADELAIDE', 'PERTH', 'CANBERRA', 'DARWIN'];

export const splitToBaseCatalog = [
  { number: 1, name: 'BASE/SYD Sydney', warehouse: 'KK Sydney', state: 'NSW' },
  {
    number: 2,
    name: 'BASE/BNE Brisbane',
    warehouse: 'KK Brisbane',
    state: 'QLD',
  },
  {
    number: 3,
    name: 'BASE/MEL Melbourne',
    warehouse: 'KK Melbourne',
    state: 'VIC',
  },
  {
    number: 4,
    name: 'BASE/ADL Adelaide',
    warehouse: 'KK Adelaide',
    state: 'SA',
  },
  { number: 5, name: 'BASE/PER Perth', warehouse: 'KK Perth', state: 'WA' },
  {
    number: 6,
    name: 'BASE/CBR Canberra',
    warehouse: 'KK Canberra',
    state: 'ACT',
  },
  { number: 7, name: 'BASE/DAR Darwin', warehouse: 'KK Darwin', state: 'NT' },
  { number: 8, name: 'BASE/HOB Hobart', warehouse: 'KK Hobart', state: 'TAS' },
];

export const statusChartLabels: string[] = [
  'Booked',
  'Allocated',
  'Stop1',
  'Stop2',
  'Stop2(POD)',
  'Completed',
  'Cancelled',
];

const ARServiceItem_TL = {
  code: 'TL',
  name: 'TailLift Required',
  specialOptionId: 1,
  chosen: false,
};

const ARServiceItem_2M = {
  code: '2M',
  name: '2 Man Required',
  specialOptionId: 19,
  chosen: false,
};
const ARServiceItem_AMSrv = {
  code: 'AMSrv',
  name: 'AM Service',
  specialOptionId: 23,
  chosen: false,
};

const ARServiceItem_PMSrv = {
  code: 'PMSrv',
  name: 'PM Service',
  specialOptionId: 24,
  chosen: false,
};

const ARServiceItem_PckReq = {
  code: 'PckReq',
  name: 'Packaging Required',
  stopAvailable: 1,
  specialOptionId: 26,
  chosen: false,
  description: '',
};

const ARServiceItem_HndLd = {
  code: 'HndLd',
  name: 'Hand Loading',
  specialOptionId: 37,
  chosen: false,
};
const ARServiceItem_HndUnLd = {
  code: 'HndUnLd',
  name: 'Hand Unloading',
  specialOptionId: 38,
  chosen: false,
};

const ARServiceItem_SatSrv = {
  code: 'SatSrv',
  name: 'Saturday Service',
  specialOptionId: 27,
  chosen: false,
  contact_name: '',
  contact_phone: '',
};

const ARServiceItem_PckUpTime = {
  code: 'PckUpTime',
  name: 'Specific Pickup Time',
  stopAvailable: 1,
  specialOptionId: 29,
  chosen: false,
  contact_name: '',
  contact_phone: '',
  date: new Date(),
  time: '12:00 PM',
};

const ARServiceItem_DelTime = {
  code: 'DelTime',
  name: 'Specific Delivery Time',
  stopAvailable: 2,
  specialOptionId: 30,
  chosen: false,
  contact_name: '',
  contact_phone: '',
  date: new Date(),
  time: '12:00 PM',
};

const ARServiceItem_Unpack = {
  code: 'Unpack',
  name: 'Unpack & remove Rubbish',
  specialOptionId: 31,
  chosen: false,
  description: '',
};

const ARServiceItem_DtRange = {
  code: 'DtRange',
  name: 'Specific Date Range',
  specialOptionId: 35,
  chosen: false,
  contact_name: '',
  contact_phone: '',
  dateFrom: new Date(),
  dateTo: new Date(),
};
const ARServiceItem_DVhcl = {
  code: 'DVhcl',
  name: 'Dedicated Vehicle',
  specialOptionId: 36,
  chosen: false,
};

export const ARServicesDeliveryList: ARServiceItemList = {
  TL: { ...ARServiceItem_TL },
  '2M': { ...ARServiceItem_2M },
  AMSrv: { ...ARServiceItem_AMSrv },
  PMSrv: { ...ARServiceItem_PMSrv },
  SatSrv: { ...ARServiceItem_SatSrv },
  DelTime: { ...ARServiceItem_DelTime },
  Unpack: { ...ARServiceItem_Unpack },
  DtRange: { ...ARServiceItem_DtRange },
  DVhcl: { ...ARServiceItem_DVhcl },
  HndUnLd: { ...ARServiceItem_HndUnLd },
};
export const ARServicesPickupList: ARServiceItemList = {
  TL: { ...ARServiceItem_TL },
  '2M': { ...ARServiceItem_2M },
  AMSrv: { ...ARServiceItem_AMSrv },
  PMSrv: { ...ARServiceItem_PMSrv },
  PckReq: { ...ARServiceItem_PckReq },
  SatSrv: { ...ARServiceItem_SatSrv },
  PckUpTime: { ...ARServiceItem_PckUpTime },
  Unpack: { ...ARServiceItem_Unpack },
  DtRange: { ...ARServiceItem_DtRange },
  DVhcl: { ...ARServiceItem_DVhcl },
  HndLd: { ...ARServiceItem_HndLd },
};

export const quantsConditionList = ['new', 'used', 'excellent', 'good', 'poor'];
export const warehouseList = {
  'KK Brisbane': 'BNE1',
  'KK Adelaide': 'ADL1',
  'KK Perth': 'PER-R',
  'KK Melbourne': 'MEL3',
  'KK Darwin': 'NT1',
  'KK Canberra': 'CBR1',
  'KK Sydney': 'SYD1',
  'KK SWH2': 'SWH2',
  'KK MWH2': 'MWH2',
};
